import { render, staticRenderFns } from "./changeOwnerDialog.vue?vue&type=template&id=796517a2"
import script from "./changeOwnerDialog.vue?vue&type=script&lang=js"
export * from "./changeOwnerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports